module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', [_c('el-form', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "ID",
      "label-width": "30px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.query.CustomerId),
      callback: function($$v) {
        _vm.$set(_vm.query, "CustomerId", $$v)
      },
      expression: "query.CustomerId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商",
      "label-width": "70px"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.query.Customer),
      callback: function($$v) {
        _vm.$set(_vm.query, "Customer", $$v)
      },
      expression: "query.Customer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主联系人",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.query.C_Name),
      callback: function($$v) {
        _vm.$set(_vm.query, "C_Name", $$v)
      },
      expression: "query.C_Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.query.Tel),
      callback: function($$v) {
        _vm.$set(_vm.query, "Tel", $$v)
      },
      expression: "query.Tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "剩余可提",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.query.min),
      callback: function($$v) {
        _vm.$set(_vm.query, "min", $$v)
      },
      expression: "query.min"
    }
  }), _vm._v(" -- "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.query.max),
      callback: function($$v) {
        _vm.$set(_vm.query, "max", $$v)
      },
      expression: "query.max"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuerySubmit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "delete2"
    },
    on: {
      "click": _vm.onQueryClean
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "padding-left": "15px"
    },
    on: {
      "click": _vm.tipBtn
    }
  }, [_vm._v("2017秋hi幼教资源包提货情况说明"), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists,
      "element-loading-text": "拼命加载中",
      "border": "",
      "router": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "100px",
      "label": "ID",
      "prop": "CustomerId"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200px",
      "label": "代理商",
      "prop": "Customer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200px",
      "label": "主联系人",
      "prop": "C_Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200px",
      "label": "联系电话",
      "prop": "C_Tel"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "2017秋hi幼教资源包提货情况",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "200px",
      "label": "本期总可提",
      "prop": "Num1"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200px",
      "label": "本期剩余可提",
      "prop": "Num2"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200px",
      "label": "本期暂扣",
      "prop": "Num3"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200px",
      "label": "后两学期暂扣",
      "prop": "Num4"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "操作",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "view",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.handleView(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看相关设备情况")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.TipdialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.TipdialogVisible = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "30px"
    }
  }, [_vm._v("\n            1：本期总可提=有效绑定园所数*60；剩余可提为代理商余下可提货部分；"), _c('br'), _vm._v("\n            2：本期暂扣=（总的已下单4000设备数*60）-本期总可提；"), _c('br'), _vm._v("\n            3：后两学期暂扣为当前学期未激活的可提数量， 需要后两学期陆续激活放出，暂不可用"), _c('br'), _vm._v("\n            4：有效绑定园所数=已绑定园所设备数-未抵扣样机数-HiA设备数-智趣坞55寸设备数"), _c('br'), _vm._v("\n            5：若当前有效绑定园所设备数大于之前的有效绑定设备数，则从本期暂扣中扣除   有效绑定设备差值*60；增加至本期总可提和剩余可提"), _c('br'), _vm._v("\n            6：新增绑定园所设备时，若当前有效绑定园所设备数小于之前的有效绑定设备数，则本期总可用和剩余可用金额不变，激活金额增加至本期暂扣中\n        ")])]), _vm._v(" "), _c('deviceView', {
    ref: "refDeviceView"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f76f47e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Agent/hiPackage/index.vue
// module id = 1464
// module chunks = 1